module.exports = "\r\n.select-language{\r\n  max-width: 150px;\r\n  font-family: Raleway;\r\n  margin: 11px 0px 11px auto;\r\n}\r\n@media(min-width: 992px){\r\n  .select-language{\r\n    max-width: 158px;\r\n    position: absolute;\r\n    right: 17px;\r\n    margin: 0;\r\n  }\r\n  \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/slots/header/header.component.css
// module id = ./src/app/slots/header/header.component.css
// module chunks = main